import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function ResetPassword() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Min. 8 caractères"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success(t("common.success"));
      navigate("/login");
    } catch (err) { toast.error(err.response?.data?.detail || t("common.error")); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("auth.resetTitle")} subtitle={t("auth.resetSub")}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div className="space-y-2">
          <Label htmlFor="password">{t("auth.newPassword")}</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
        </div>
        <Button type="submit" className="w-full rounded-full" disabled={loading || !token} data-testid="reset-submit">
          {loading ? t("common.loading") : t("auth.reset")}
        </Button>
        <p className="text-center text-sm"><Link to="/login" className="text-primary">{t("auth.backToLogin")}</Link></p>
      </form>
    </AuthShell>
  );
}
